module.exports = __webpack_public_path__ + "img/icon_3.67ccfa56.png";